import { NetworkManager, MethodRequest_e } from "../../managers/NetworkManager";

/**
 * @author Lucas Fridez <lucas@fridez.dev>
 * @client Gigon SA
 * @project webapp-scan
 * @file src\app\framework\user\User.ts
 * @copyright 2018 Lucas Fridez
 */

/**
 * @description Class User which correspond to the table tb_user in Back-End
 * @author Lucas Fridez <fridez.lucas@gmail.com>
 * @export
 * @class User
 */
export class User {
    public static async getUserById(id: string | number): Promise<User> {
        return new User(await NetworkManager.request(`users/${id}`, MethodRequest_e.GET));
    }

    public static async getAllUsers() {
        const usersClass: Array<any> = [];
        const json = await NetworkManager.request("users", MethodRequest_e.GET);

        json.forEach((warehouse: any) => {
            usersClass.push(new User(warehouse));
        });

        return usersClass;
    }

    private _id: string;
    private _email: string;
    private _name: string;
    private _surname: string;
    private _username: string;
    private _profile: number;
    private _phone: string;
    private _title: string;

    /**
     * Creates an instance of User.
     * @author Lucas Fridez <lucas@fridez.dev>
     * @param {any} json json object received from API
     * @memberof User
     */
    constructor(json: any) {
        this._id = json.id;
        this._name = json.name;
        this._surname = json.surname;
        this._username = json.pseudo;
        this._email = json.email;
        this._profile = json.profile;
        this._phone = json.phone;
        this._title = json.title;
    }

    /**
     * @description Return the id
     * @author Lucas Fridez <lucas@fridez.dev>
     * @readonly
     * @memberof User
     */
    public get id(): string {
        return this._id;
    }

    /**
     * @description Return the name
     * @author Lucas Fridez <lucas@fridez.dev>
     * @readonly
     * @memberof User
     */
    public get name(): string {
        return this._name;
    }

    /**
     * @description Return the surname
     * @author Lucas Fridez <lucas@fridez.dev>
     * @readonly
     * @memberof User
     */
    public get surname(): string {
        return this._surname;
    }

    /**
     * @description Return the username
     * @author Lucas Fridez <lucas@fridez.dev>
     * @readonly
     * @memberof User
     */
    public get username(): string {
        return this._username;
    }

    /**
     * @description Return the profile
     * @author Lucas Fridez <lucas@fridez.dev>
     * @readonly
     * @memberof User
     */
    public get profile(): number {
        return this._profile;
    }

    /**
     * @description Return the email
     * @readonly
     * @type {string}
     * @memberof User
     */
    public get email(): string {
        return this._email;
    }

    /**
     * @description Return the phone number
     * @readonly
     * @type {string}
     * @memberof User
     */
    public get phone(): string {
        return this._phone;
    }

    /**
     * @description Return the title
     * @author Lucas Fridez <lucas@fridez.dev>
     * @readonly
     * @memberof User
     */
    public get title(): string {
        return this._title;
    }
}



// WEBPACK FOOTER //
// ./src/app/framework/user/User.ts